import {
  Component,
  OnInit,
  Input,
  HostBinding
} from '@angular/core';

@Component({
  selector: 'awair-report-card-content',
  templateUrl: './report-card-content.component.html',
  styleUrls: ['./report-card-content.component.scss']
})

export class ReportCardContentComponent implements OnInit {

  private _condition: string = 'No Data';
  get condition(): string {
    return this._condition;
  }
  @Input()
  set condition(condition: string) {
    if (this.colorConditionMap[condition] != null) {
      this.indexColor = this.colorConditionMap[condition];
      this._condition = condition;
    } else {
      this.indexColor = '#CDD3D8';
      this._condition = 'No Data';
    }
  }

  private _width: string;
  get width(): string {
    return this._width;
  }
  @Input()
  set width(width: string) {
    if (width != null) {
      this._width = width;
      this.styleWidth = this._width;
    }
  }

  @HostBinding('style.width') styleWidth: string;

  @Input() header: string;
  @Input() value: string | number;
  @Input() unit: string;
  @Input() percentage: string;

  indexColor: string = '#CDD3D8';

  private colorConditionMap = {
    'good': '#4FCC53',
    'fair': '#F8A91C',
    'poor': '#E63740'
  };

  constructor() { }

  ngOnInit() {
  }
}
